export default "__VITE_ASSET__Dc684R2A__"